module.exports = __webpack_public_path__ + "static/Adam savage-4ebbe037e359108f12f2baca83dbe126.png";